import type { ModuleColumnDefinition } from '../module'
import { FieldTypeEnum } from '../custom-field.types'
import {
  Expense,
  ExpenseKindEnum,
  ExpenseReimbursementStatusEnum,
  ExpenseWorkflowStatusEnum,
} from '../expense'
import { ModuleTypeEnum } from '../module'

export const EXPENSE_STANDARD_COLUMNS: ModuleColumnDefinition[] = [
  {
    id: 'expenseDate',
    name: 'expenseDate' as keyof Expense,
    label: 'Date',
    description: 'Date of the expense',
    isVisible: true,
    isRequired: true,
    isSystem: true,
    isFixed: true,
    order: 0,
    fieldType: FieldTypeEnum.enum.DATE,
    width: '130px',
    minWidth: '110px',
  },
  {
    id: 'merchant',
    name: 'merchant' as keyof Expense,
    label: 'Merchant',
    description: 'Merchant or payee',
    isVisible: true,
    isRequired: true,
    isSystem: true,
    isFixed: false,
    order: 1,
    fieldType: FieldTypeEnum.enum.STRING,
    width: '220px',
    minWidth: '180px',
  },
  {
    id: 'kind',
    name: 'kind' as keyof Expense,
    label: 'Kind',
    description: 'Expense type',
    isVisible: true,
    isRequired: true,
    isSystem: false,
    isFixed: false,
    order: 2,
    fieldType: FieldTypeEnum.enum.DROPDOWN,
    width: '150px',
    minWidth: '130px',
    options: Object.values(ExpenseKindEnum).map(value => ({
      value,
      label:
        value === ExpenseKindEnum.REIMBURSEMENT
          ? 'Reimbursement'
          : 'Company Paid',
    })),
  },
  {
    id: 'workflowStatus',
    name: 'workflowStatus' as keyof Expense,
    label: 'Status',
    description: 'Workflow status',
    isVisible: true,
    isRequired: true,
    isSystem: false,
    isFixed: false,
    order: 3,
    fieldType: FieldTypeEnum.enum.DROPDOWN,
    width: '170px',
    minWidth: '140px',
    options: Object.values(ExpenseWorkflowStatusEnum).map(value => ({
      value,
      label: value.replace(/_/g, ' '),
    })),
  },
  {
    id: 'reimbursementStatus',
    name: 'reimbursementStatus' as keyof Expense,
    label: 'Reimbursement',
    description: 'Reimbursement status',
    isVisible: true,
    isRequired: false,
    isSystem: false,
    isFixed: false,
    order: 4,
    fieldType: FieldTypeEnum.enum.DROPDOWN,
    width: '180px',
    minWidth: '150px',
    options: Object.values(ExpenseReimbursementStatusEnum).map(value => ({
      value,
      label: value.replace(/_/g, ' '),
    })),
  },
  {
    id: 'totalAmount',
    name: 'totalAmount' as keyof Expense,
    label: 'Amount',
    description: 'Total expense amount',
    isVisible: true,
    isRequired: true,
    isSystem: false,
    isFixed: false,
    order: 5,
    fieldType: FieldTypeEnum.enum.NUMBER,
    width: '130px',
    minWidth: '110px',
  },
  {
    id: 'paymentMethod',
    name: 'paymentMethod' as keyof Expense,
    label: 'Payment Method',
    description: 'Payment method',
    isVisible: false,
    isRequired: false,
    isSystem: false,
    isFixed: false,
    order: 6,
    fieldType: FieldTypeEnum.enum.STRING,
    width: '160px',
    minWidth: '140px',
  },
  {
    id: 'createdAt',
    name: 'createdAt' as keyof Expense,
    label: 'Created',
    description: 'Date created',
    isVisible: false,
    isRequired: false,
    isSystem: true,
    isFixed: false,
    order: 7,
    fieldType: FieldTypeEnum.enum.DATETIME,
    width: '180px',
    minWidth: '140px',
  },
]

export function getExpenseColumns(): ModuleColumnDefinition[] {
  return EXPENSE_STANDARD_COLUMNS
}

export function getExpenseModuleType(): ModuleTypeEnum {
  return ModuleTypeEnum.EXPENSE
}
